import type { TicketStatus } from '@/types/ticket'
import { nextStatuses, statusLabels } from '@/lib/status'
import { railSelectClass } from './railSelect'

export function StatusSelect({ value, onChange, disabled }: { value: TicketStatus; onChange: (s: TicketStatus) => void; disabled?: boolean }) {
  const options: TicketStatus[] = [value, ...nextStatuses(value)]
  return (
    <select disabled={disabled} value={value} onChange={e => onChange(e.target.value as TicketStatus)} className={railSelectClass}>
      {options.map(s => <option key={s} value={s}>{statusLabels[s]}</option>)}
    </select>
  )
}
